export default "__VITE_ASSET__BogDrqs5__"